<template>
  <v-layout wrap>
    <v-flex xs12 pb-0>
      <v-layout wrap align-center>
        <v-flex xs12 sm6 md6 lg6>
          <h1 class="headline">{{ $t('dtp.title') }}</h1>
        </v-flex>

        <v-flex xs12 sm6 md6 lg6>
          <v-layout wrap align-center justify-end>
            <v-btn
              v-if="$can('car_accident_add')"
              to="/dtp/add"
              color="warning mt-2"
              large
              depressed
              @click="dialog = true"
            >
              {{ $t('dtp.add') }}
            </v-btn>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-flex>

    <dtp-table class="mt-5" />
  </v-layout>
</template>

<script>
import DtpTable from '@/components/dtp/DtpTable.vue';

export default {
  components: { DtpTable },
  data: () => ({
    dialog: false,
  }),
};
</script>

<style></style>
